import * as Sentry from '@sentry/browser'
import { kAgentV2RouterApiBasePath } from '@/constants/constants-api-paths'
import { kPaxtonAppApiRESTBaseUrl } from '@/constants/constants-links'
import { getResponseDebugContext, getTopLevelKeys } from '@/util/api/response-body'
import { ApiResponsePayloadError } from '@/util/errors/api-response-payload-error'
import { AgentV2ConversationSummary, AgentV2ConversationSummarySchema } from '@/agent-v2/store/schemas'
import { agentV2Request } from './agent-v2-request'

export async function patchRenameAgentV2ConversationTitle(input: { conversationId: string; title: string }): Promise<AgentV2ConversationSummary> {
  const url = `${kPaxtonAppApiRESTBaseUrl()}${kAgentV2RouterApiBasePath}/conversations/${input.conversationId}/title/rename`
  return agentV2Request({
    url,
    method: 'PATCH',
    body: JSON.stringify({ title: input.title }),
    sentryEndpoint: 'PATCH /api/v2/agent/conversations/{conversation_id}/title/rename',
    parseResponse: (data, { response, sentryTags }) => {
      const parsed = AgentV2ConversationSummarySchema.safeParse(data)
      if (parsed.success) return parsed.data

      Sentry.withScope((scope) => {
        scope.setTags(sentryTags)
        Sentry.captureException(new Error('Agent v2 rename response schema validation failed'), {
          extra: {
            ...getResponseDebugContext(response, url),
            conversationId: input.conversationId,
            responseKeys: getTopLevelKeys(data),
            issues: parsed.error.issues,
          },
        })
      })
      throw new ApiResponsePayloadError(response.status, 'Invalid Agent v2 rename response shape', parsed.error.issues)
    },
  })
}
